import { __, sprintf } from '@wordpress/i18n';
import AJAX from './class.AJAX';
import Abstract from './class.Abstract';
import { qs } from '../dom-helpers';

class ProductSearch extends Abstract {
  constructor() {
    super();

    if (!qs('.search-form')) return;

    this.searchForm = qs('.search-form');
    this.searchInput = qs('.search-input', this.searchForm);
    this.resultsContainer = qs('.search-results-container');
    this.resultTable = qs('.search-results__table');

    this._run();
  }

  _run() {
    this._initEvents();
    return this;
  }

  _initEvents() {
    this._setOnChangeEvent();
    this._setFormSubmitEvent();
    this._onOutClicking();
    this._initCountButtons();
    this._addToCartOnButtonClick();
  }

  _setOnChangeEvent() {
    let timeoutID = null;
    const _this = this;

    this.searchInput.addEventListener('keyup', () => {
      clearTimeout(timeoutID);
      timeoutID = setTimeout(() => {
        if (_this.searchInput.value !== '') {
          _this.search();
        } else {
          _this.resultTable.innerHTML = '';
          _this.hideContainer();
        }
      }, 1500);
    });
  }

  _setFormSubmitEvent() {
    this.searchForm.addEventListener('submit', (e) => {
      e.preventDefault();
      this.search();
    });
  }

  _onOutClicking() {
    document.addEventListener('click', (e) => {
      const el = e.target;
      if (!el.closest('.search-form')) this.hideContainer();
    });
  }

  _initCountButtons() {
    this.resultsContainer.addEventListener('click', (e) => {
      const node = e.target;

      if (!node.classList.contains('product__quantity-btn')) return;
      e.preventDefault();

      const buttonType = node.classList.contains('product__quantity-btn--plus') ? 'inc' : 'dec';
      const addToCartButton = node.closest('.search-result').querySelector('.search-result__add-to-cart-btn');
      let newValue = 0;

      if (buttonType === 'inc') {
        newValue = parseInt(node.previousElementSibling.value, 10) + 1;
        node.previousElementSibling.value = newValue;
      } else {
        newValue = parseInt(node.nextElementSibling.nextElementSibling.value, 10) - 1;
        if (newValue <= 1) newValue = 1;
        node.nextElementSibling.nextElementSibling.value = newValue;
      }

      addToCartButton.dataset.quantity = newValue;
    });
  }

  _addToCartOnButtonClick() {
    this.resultsContainer.addEventListener('click', (e) => {
      const node = e.target;

      if (node.classList.contains('search-result__add-to-cart-btn')) {
        e.preventDefault();

        const productID = node.dataset.id;
        const { quantity } = node.dataset;

        this.addToCart(productID, quantity);
      }
    });
  }

  search() {
    const query = this.searchInput.value.trim();
    this._requestProducts(query);
  }

  _requestProducts(query) {
    const _this = this;

    AJAX.post({
      action: 'mst_somi_search_product',
      data: { query },
      success(resp) {
        if (resp.data.result) {
          _this._convertProductsArrayToTable(resp.data.result);
        } else {
          _this.hideContainer();
        }
      },
      beforeSend() {
        qs('.search-input', _this.couponForm).readOnly = true;
      },
      complete() {
        qs('.search-input', _this.couponForm).readOnly = false;
      },
    });
  }

  addToCart(productID, quantity) {
    const _this = this;
    const settings = {
      ...this.getBlockSettings(),
      message: Abstract.getI18n().please_wait,
    };

    AJAX.post({
      action: 'woocommerce_add_to_cart',
      data: { product_id: productID, quantity },
      success() {
        Abstract.refreshFragments();

        if (_this.isCheckout) {
          location.reload();
        } else {
          Abstract.updateCart();
        }
      },
      beforeSend() {
        jQuery(_this.resultsContainer).block(settings);
      },
      complete() {
        jQuery(_this.resultsContainer).unblock();
      },
    });
  }

  _convertProductsArrayToTable(products) {
    if (!products.length) return;

    this.resultTable.innerHTML = '';

    products.forEach((product) => {
      this.resultTable.innerHTML += this._generateTableItem(product);
    });

    this.showContainer();
  }

  _generateTableItem(productData) {

    const {
      image, title, price, id, permalink, cartUrl,
    } = productData;

    const actions = cartUrl.length > 0 ? `
        <td>
          <div class="product__quantity">
            <button class="product__quantity-btn product__quantity-btn--minus"
                    aria-label="${sprintf(__('Decrease quantity of %s', 'mst_somi_js'), title)}">
            </button>

            <label class="visually-hidden" for="product-${id}-quantity">
              ${sprintf(__('Quantity of %s', 'mst_somi_js'), title)}
            </label>

            <input type="number" name="product-${id}-quantity" value="1">

            <button class="product__quantity-btn product__quantity-btn--plus"
                    aria-label="${sprintf(__('Increase quantity of %s', 'mst_somi_js'), title)}">
            </button>
          </div>
        </td>

        <td>
          <a href="${cartUrl}"
           class="search-result__add-to-cart-btn"
           data-id="${id}"
           data-quantity="1">
            <!-- ${__('Add to cart', 'mst_somi_js')} -->
            ${Abstract.getI18n().add_to_cart}
          </a>
        </td>
    ` : '';

    return `
      <tr class="search-result">

        <td>
          <a href="${permalink}">
            <img src="${image}" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt="${title}">
          </a>
        </td>

        <td>
          <a href="${permalink}" class="search-result__product">
            <span class="search-result__product-title" role="heading">${title}</span>
            <span class="search-result__product-price">${price}</span>
          </a>
        </td>

        ${actions}

      </tr>
    `;
  }

  showContainer() {
    Abstract.fadeIn(this.resultsContainer);
  }

  hideContainer() {
    Abstract.fadeOut(this.resultsContainer);
  }
}

export default ProductSearch;
